var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockTimeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0834 17.5003C32.0834 25.5503 25.55 32.0837 17.5 32.0837C9.45002 32.0837 2.91669 25.5503 2.91669 17.5003C2.91669 9.45033 9.45002 2.91699 17.5 2.91699C25.55 2.91699 32.0834 9.45033 32.0834 17.5003Z",
    stroke: "#1D2C49",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9105 22.1376L18.3897 19.4396C17.6022 18.973 16.9605 17.8501 16.9605 16.9313V10.9521",
    stroke: "#F4978E",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockTimeIcon);
export default __webpack_public_path__ + "static/media/clock-time-icon.0837db140a12a2a0682d48c03b2380e5.svg";
export { ForwardRef as ReactComponent };